"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_OPTIONS = exports.TRANSAK_API_ENDPOINTS = exports.TRANSAK_API_URL_STAGE = exports.TRANSAK_API_URL_PROD = void 0;
const visa_master_png_1 = __importDefault(require("../../../../static/payments/visa_master.png"));
const googlepay_svg_1 = __importDefault(require("../../../../static/payments/googlepay.svg"));
const fasterpayments_svg_1 = __importDefault(require("../../../../static/payments/fasterpayments.svg"));
const inrbanktransfer_svg_1 = __importDefault(require("../../../../static/payments/inrbanktransfer.svg"));
const inrupi_svg_1 = __importDefault(require("../../../../static/payments/inrupi.svg"));
const sepa_svg_1 = __importDefault(require("../../../../static/payments/sepa.svg"));
const applepay_svg_1 = __importDefault(require("../../../../static/payments/applepay.svg"));
const cashapp_png_1 = __importDefault(require("../../../../static/payments/cashapp.png"));
const wirepayment_svg_1 = __importDefault(require("../../../../static/payments/wirepayment.svg"));
const astropay_png_1 = __importDefault(require("../../../../static/payments/astropay.png"));
const pix_png_1 = __importDefault(require("../../../../static/payments/pix.png"));
const gcash_svg_1 = __importDefault(require("../../../../static/payments/gcash.svg"));
const paymaya_svg_1 = __importDefault(require("../../../../static/payments/paymaya.svg"));
const bpi_svg_1 = __importDefault(require("../../../../static/payments/bpi.svg"));
const unionbank_svg_1 = __importDefault(require("../../../../static/payments/unionbank.svg"));
const grabpay_svg_1 = __importDefault(require("../../../../static/payments/grabpay.svg"));
const shopeepay_svg_1 = __importDefault(require("../../../../static/payments/shopeepay.svg"));
const pse_svg_1 = __importDefault(require("../../../../static/payments/pse.svg"));
exports.TRANSAK_API_URL_PROD = "https://api.transak.com";
exports.TRANSAK_API_URL_STAGE = "https://api-stg.transak.com";
exports.TRANSAK_API_ENDPOINTS = {
    PRICE: "/api/v2/currencies/price",
    CRYPTOCURRENCIES: "/api/v2/currencies/crypto-currencies",
    COUNTRIES: "/api/v2/countries",
    FIAT: "/api/v2/currencies/fiat-currencies",
};
exports.PAYMENT_OPTIONS = [
    { id: "credit_debit_card", icon: visa_master_png_1.default },
    { id: "google_pay", icon: googlepay_svg_1.default },
    { id: "gbp_bank_transfer", icon: fasterpayments_svg_1.default },
    { id: "inr_bank_transfer", icon: inrbanktransfer_svg_1.default },
    { id: "inr_upi", icon: inrupi_svg_1.default },
    { id: "sepa", icon: sepa_svg_1.default },
    { id: "apple_pay", icon: applepay_svg_1.default },
    { id: "pm_cash_app", icon: cashapp_png_1.default },
    { id: "pm_jwire", icon: wirepayment_svg_1.default },
    { id: "pm_astropay", icon: astropay_png_1.default },
    { id: "pm_pix", icon: pix_png_1.default },
    { id: "pm_gcash", icon: gcash_svg_1.default },
    { id: "pm_paymaya", icon: paymaya_svg_1.default },
    { id: "pm_bpi", icon: bpi_svg_1.default },
    { id: "pm_ubp", icon: unionbank_svg_1.default },
    { id: "pm_grabpay", icon: grabpay_svg_1.default },
    { id: "pm_shopeepay", icon: shopeepay_svg_1.default },
    { id: "pm_pse", icon: pse_svg_1.default },
];
//# sourceMappingURL=constants.js.map